import React from 'react';
import {
  DefaultModalProps,
  withLocationStateModal,
  useOpenModal,
} from 'utils/modals';

import { Box, Typography, Link, Button } from '@mui/material';

import { DefaultModal } from '@libs/ui/components/modals';

import { PerksModals } from './types';

interface DisclaimerProps {}

// Modal component
interface DisclaimerModalProps extends DefaultModalProps<void> {}

const DisclaimerModalComponent = ({ close, isOpen }: DisclaimerModalProps) => {
  return (
    <DefaultModal
      open={isOpen}
      handleClose={close}
      title="Disclaimer"
      actions={
        <Button
          fullWidth
          variant="contained"
          color="info"
          onClick={close}
          size="large"
        >
          Got it
        </Button>
      }
    >
      <Box sx={{ textAlign: 'left' }}>
        <Typography variant="body1" paragraph mt={4}>
          Perks listed here are offered by third-party providers. OpenTalent
          simply shares these opportunities and is not responsible for the
          offers or any issues that may arise.
        </Typography>

        <Typography variant="body1" paragraph>
          For questions or disputes, please contact the provider directly. You
          can also email{' '}
          <Typography
            component="a"
            href="mailto:hello@opentalent.co"
            color="info.main"
            sx={{ textDecoration: 'none' }}
          >
            hello@opentalent.co
          </Typography>{' '}
          and we'll do our best to help mediate, though resolution isn't
          guaranteed.
        </Typography>

        <Typography variant="body2" color="text.secondary">
          By using these perks, you acknowledge and agree to these terms.
        </Typography>
      </Box>
    </DefaultModal>
  );
};

const DisclaimerModal = withLocationStateModal<void>({
  id: PerksModals.DISCLAIMER,
})(DisclaimerModalComponent);

// Hook
const useOpenDisclaimerModal = () => useOpenModal<void>(PerksModals.DISCLAIMER);

// Main component
export const Disclaimer: React.FC<DisclaimerProps> = () => {
  const openDisclaimerModal = useOpenDisclaimerModal();

  return (
    <>
      <Box>
        <Typography variant="body2" color="text.secondary">
          Any questions regarding Perks? Please{' '}
          <Link
            component="button"
            variant="body2"
            onClick={() => openDisclaimerModal()}
            color="info.main"
            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
          >
            read the disclaimer
          </Link>
          .
        </Typography>
      </Box>
      <DisclaimerModal />
    </>
  );
};
